import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function AppLandingV2Redirect() {
  const location = useLocation();

  useEffect(() => {
    const basePath = import.meta.env.BASE_URL.endsWith("/")
      ? import.meta.env.BASE_URL
      : `${import.meta.env.BASE_URL}/`;

    window.location.replace(`${basePath}app/v2/index.html${location.search}${location.hash}`);
  }, [location.hash, location.search]);

  return null;
}
